import React, { useEffect, useState } from 'react';
import { ToolOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import ModalComponent from 'components/ModalComponent';
import IFrameContainer from 'containers/shared/IFrameContainer';
import { HELPDESK_TICKET_PATH } from 'constants/paths';
import { t } from 'helpers/i18n';
import { getSrc } from 'helpers/url';
import configHelpers from 'helpers/config';
import iframeHelpers from 'helpers/iframe';

const { getCommonConfig } = configHelpers;
const { getTrustedChildOrigin, isBaseUrlOrigin } = iframeHelpers;
const { baseSposUrl } = getCommonConfig();

const TICKET_URL = getSrc(baseSposUrl, HELPDESK_TICKET_PATH);
const REQUEST_TICKET_MESSAGE_TYPE = 'request_ticket';

// The create-ticket URL stays under TICKET_URL; payload values only fill its query string.
export const buildCreateTicketUrl = (payload?: {
  traceId?: unknown;
  imgUrl?: unknown;
}) => {
  if (!isBaseUrlOrigin(TICKET_URL)) return null;
  const url = new URL(`${TICKET_URL}/create`);
  url.searchParams.set('traceId', String(payload?.traceId ?? ''));
  url.searchParams.set('imgUrl', String(payload?.imgUrl ?? ''));
  return url.toString();
};

const Ticket = () => {
  const [visible, setVisible] = useState(false);
  const [frameUrl, setFrameUrl] = useState(TICKET_URL);
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (
        event.data?.type !== REQUEST_TICKET_MESSAGE_TYPE ||
        !getTrustedChildOrigin(event)
      ) {
        return;
      }
      const createTicketUrl = buildCreateTicketUrl(event.data.payload);
      if (!createTicketUrl) return;
      setVisible(true);
      setFrameUrl(createTicketUrl);
    };
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <>
      <Button icon={<ToolOutlined />} onClick={() => setVisible(true)}>
        {t('ContactSupport')}
      </Button>
      <ModalComponent
        component={IFrameContainer}
        iFrameSrc={frameUrl}
        showModal={visible}
        setShowModal={setVisible}
      />
    </>
  );
};

export default Ticket;
